/** iter 42 — Mobile / Account tab. */
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../lib/auth";
import { api } from "../../lib/api";
import MobileShell from "../MobileShell";

export default function MAccount() {
  const navigate = useNavigate();
  const { user, setUser, logout } = useAuth();
  const [saving, setSaving] = useState(false);

  const setTheme = async (next) => {
    setSaving(true);
    try {
      await api.patch("/users/me", { theme: next });
      setUser({ ...user, theme: next });
    } finally { setSaving(false); }
  };

  if (!user) return null;
  return (
    <MobileShell title="Account">
      <div className="m-card" data-testid="m-account-card">
        <div className="m-card-title">{user.name || user.email}</div>
        <div className="m-card-sub">{user.email}</div>
        <div style={{ marginTop: 6 }}>
          <span className="m-chip">{user.role || "user"}</span>
          <span className="m-chip">{user.org_name || "—"}</span>
        </div>
      </div>

      <div className="m-card">
        <div className="m-field-label">Theme</div>
        <div className="m-row">
          <button
            type="button"
            className={`m-btn ${user.theme !== "dark" ? "m-btn-primary" : ""}`}
            onClick={() => setTheme("light")}
            disabled={saving}
            data-testid="m-theme-light"
          >Light</button>
          <button
            type="button"
            className={`m-btn ${user.theme === "dark" ? "m-btn-primary" : ""}`}
            onClick={() => setTheme("dark")}
            disabled={saving}
            data-testid="m-theme-dark"
          >Dark</button>
        </div>
      </div>

      <button
        type="button"
        className="m-btn"
        onClick={() => { logout(); }}
        data-testid="m-logout-btn"
      >SIGN OUT</button>
    </MobileShell>
  );
}
